import { getDB } from "src/db/databases"
import { useCacheStore } from "src/stores/cacheStore"
import { Log } from "src/util/classes/log"
import { getItemModel } from "src/util/http/csi/itemModels"

export async function getItemModelData(itemModelId: string | null) {
  if (itemModelId) {
    try {
      const cacheStore = useCacheStore()
      const itemModelInCache = cacheStore.item_model.get(itemModelId)

      if (itemModelInCache) {
        return itemModelInCache
      } else {
        const db = await getDB()
        const itemModelInDB = await db.item_model.findOne(itemModelId).exec()

        if (itemModelInDB) {
          const model = itemModelInDB.toMutableJSON()
          cacheStore.item_model.set(model.id, model)
          return model
        } else {
          return await getItemModel({}, itemModelId)
        }
      }
    } catch (error) {
      Log.error({
        message: "An error occurred while fetching Item Model data",
        error,
      })
    }
  }
}
